import React from 'react';
import Section from '../../shared/reusables/Section';

const EducationSection = ({ education, language }) => {
    const title = language === 'en' ? 'Education' : 'Opleiding';

    return (
        <Section title={title}>
            <div className="timeline">
                {education.map((edu, index) => (
                    <div key={index} className="timeline-item">
                        <div className="timeline-dot" />
                        <div className="timeline-content">
                            <div className="timeline-header">
                                <span className="timeline-title">{edu.degree}</span>
                                <span className="timeline-period">{edu.period}</span>
                            </div>
                            <div className="timeline-company">{edu.institution} · {edu.location}</div>
                        </div>
                    </div>
                ))}
            </div>
        </Section>
    );
};

export default EducationSection;
